import React from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import { Area } from "../../../models/Area";
import { CalendarEvent } from "../../../models/CalendarEvent";
import { Delivery } from "../../../models/Delivery";
import { Dropoff } from "../../../models/Dropoff";
import { Equipment } from "../../../models/Equipment";
import { Gate } from "../../../models/Gate";
import { GateToDropoffRoute } from "../../../models/GateToDropoffRoute";
import { HaulRoute } from "../../../models/HaulRoute";
import { mappableName } from "../../Helper/Map";
import { ShareItemType } from "../../PlotAPI/Share";
import Modal from "../Modal";
import ShareProjectItemBody from "./shareProjectItemBody";

interface Props {
    showModal: boolean;
    hideModal: () => void;
    shareType: ShareItemType;
    projectToken: string;
    // Optional props
    currentObject?: Area | Dropoff | Equipment | Gate | HaulRoute | GateToDropoffRoute;
    calendarEvent?: CalendarEvent;
    delivery?: Delivery;
}

const ShareProjectItemModal: React.FC<Props> = ({
    showModal,
    hideModal,
    currentObject,
    calendarEvent,
    delivery,
    shareType,
    projectToken,
}) => {
    const globalStoreContext = React.useContext(GlobalStoreContext);

    if (["location", "dropoff", "equipment"].includes(shareType) && !currentObject) {
        return <></>;
    }

    const itemLabel = () => {
        switch (shareType) {
            case "location":
                return (currentObject && mappableName(currentObject)) || "Location";
            case "dropoff":
                return (currentObject && mappableName(currentObject)) || "Drop-off";
            case "equipment":
                return (currentObject && mappableName(currentObject)) || "Equipment";
            case "project":
                return globalStoreContext.currentProjectInfo.project_name;
            case "delivery":
                return calendarEvent?.name || "Delivery";
        }
    };

    return (
        <Modal
            destroyOnHidden={true}
            title={`Share ${itemLabel()}`}
            open={showModal}
            onCancel={hideModal}
            onClose={hideModal}
            width={"50vw"}
            footer={null}
        >
            <ShareProjectItemBody
                shareType={shareType}
                projectToken={projectToken}
                currentObject={currentObject}
                calendarEvent={calendarEvent}
                delivery={delivery}
                onFinish={hideModal}
            />
        </Modal>
    );
};

export default ShareProjectItemModal;
